export default __webpack_public_path__ + "static/media/youtube.2c55da1b.svg";